import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import mixin from '@/plugins/mixins/mixin'
import formMixin from '@/plugins/mixins/formMixin'
import store from './store'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import App from './App.vue'
import VueMq from 'vue-mq'
import VueMask from 'v-mask'
import './plugins/filter';
require('./css/index.css')
import '../public/css/materialdesignicons.min.css'
import Axios from './plugins/axios'
import TefAxios from './plugins/tefAxios'
import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib'
import useIdle from './plugins/useIdle'
import '@mdi/font/css/materialdesignicons.css'
import FingerprintPlugin from '@/plugins/fingerprint'

// Directives
import flashOnChange from "@/plugins/directives/flashOnChange"

Vue.directive("flash-on-change", flashOnChange)


Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField,{
	locale: 'pt-BR',
	decimalLength: 2,
	autoDecimalMode: true,
	min: null,
	max: null,
	defaultValue: 0,
    valueAsInteger: false,
    allowNegative: false
})
Vue.prototype.$axios = Axios();
Vue.prototype.$tefAxios = TefAxios();

Vue.config.productionTip = false

Vue.mixin(mixin)
Vue.mixin(formMixin)
Vue.use(VueMq, {
	breakpoints: { // default breakpoints - customize this
		sm: 450,
		md: 1000,
		lg: Infinity,
	},
	defaultBreakpoint: 'sm' // customize this for SSR
})

Vue.use(VueMask, {
	placeholders: {
		U: /([0-9A-ZÀ-Ú ])+/, //ONLY UPPERCASE LETTERS
	}
})

Vue.use(FingerprintPlugin)

new Vue({
	vuetify,
	router,
	store,
	render: h => h(App)
}).$mount('#app')

store.watch(
	state => state.lxl.lxl,
	(newLxl) => {
		if (newLxl?.lxllogin && newLxl?.lxlnaorenv) {
			Vue.use(useIdle)
		}
	}
)